<template>
  <b-form @submit.prevent>
    <b-row>
      <b-col md="4">
        <b-form-group label="Grupo de período">
          <b-form-select v-model="grupoPeriodo" :options="periodosOptions" />
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" lg="6" xl="4">
        <b-form-group>
          <label>Fornecedor</label>
          <b-form-select :plain="true" :options="fornecedores" text-field="nome" value-field="codFornecedor"
            v-model="fornecedor"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4" lg="4" xl="3">
        <b-form-group>
          <label>Contrato</label>
          <b-input-group>
            <b-form-input type="text" placeholder="Digite o número do contrato" v-model="numeroContrato"
              v-mask="'AA###/##'"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col   md="4" lg="4" xl="4" >
        <b-form-group>
          <label>Gestor/Solicitante</label>
          <b-form-select :plain="true" :options="responsaveis" text-field="nome" value-field="codFuncionario"
            v-model="responsavel"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col v-if="unidades" md="4" lg="4" xl="4">
        <b-form-group>
          <label>Unidade do Contrato</label>
          <b-form-select :plain="true" :options="unidades" text-field="nome" value-field="codUnidade"
            v-model="unidade"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    fornecedores: {
      type: Array,
      default: () => []
    },
    responsaveis: {
      type: Array,
      default: () => []
    },
    unidades: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      grupoPeriodo: '',
      responsavel: null,
      unidade: null,
      fornecedor: null,
      numeroContrato: null,
      periodosOptions: [
        { value: '', text: 'Selecione' },
        { value: 'ate30', text: 'Atraso até 30 dias' },
        { value: '31a45', text: 'Atraso de 31 a 45 dias' },
        { value: '46a60', text: 'Atraso de 46 a 60 dias' },
        { value: 'acima60', text: 'Atraso acima de 60 dias' }
      ]
    }
  },
  watch: {
    numeroContrato() {
      this.$emit('filtroAtualizado', this.filtro)
    },

    responsavel() {
      this.$emit('filtroAtualizado', this.filtro)
    },

    unidade() {
      this.$emit('filtroAtualizado', this.filtro)
    },

    fornecedor() {
      this.$emit('filtroAtualizado', this.filtro)
    },
    
    grupoPeriodo() {
      this.$emit('filtroAtualizado', this.filtro)
    },

    
  },
  computed:{
    filtro() {
      return {
        grupoPeriodo: this.grupoPeriodo,
        numeroContrato: this.numeroContrato,
        responsavel: this.responsavel,
        unidade: this.unidade,
        fornecedor: this.fornecedor,
      }
    }
  },

  mounted() {
    
  }
}
</script>